import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../api';
import { useSearchParams } from 'react-router-dom';
import DetailPanel from '../components/DetailPanel';
import { useAuth } from '../AuthContext';
import { OPERATIONS_TABS } from '../config/pages';
import FinalFilesSection from '../components/FinalFilesSection';

// ── Platform SVG logos (inline) ──────────────────────────────────────────────
const PLATFORM_SVG = {
  Facebook:  <svg viewBox="0 0 24 24" width="14" height="14" fill="#1877f2"><path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.792-4.697 4.532-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.513c-1.491 0-1.956.93-1.956 1.887v2.265h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/></svg>,
  Instagram: <svg viewBox="0 0 24 24" width="14" height="14"><defs><radialGradient id="ig" cx="30%" cy="107%" r="150%"><stop offset="0%" stopColor="#fdf497"/><stop offset="5%" stopColor="#fdf497"/><stop offset="45%" stopColor="#fd5949"/><stop offset="60%" stopColor="#d6249f"/><stop offset="90%" stopColor="#285AEB"/></radialGradient></defs><path fill="url(#ig)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>,
  LinkedIn:  <svg viewBox="0 0 24 24" width="14" height="14" fill="#0a66c2"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>,
  YouTube:   <svg viewBox="0 0 24 24" width="14" height="14" fill="#ff0000"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>,
  WhatsApp:  <svg viewBox="0 0 24 24" width="14" height="14" fill="#25d366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>,
  Twitter:   <svg viewBox="0 0 24 24" width="14" height="14" fill="#000"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.259 5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>,
  Pinterest: <svg viewBox="0 0 24 24" width="14" height="14" fill="#bd081c"><path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>,
};

const PLATFORM_COLOR = {
  Facebook:'#1877f2', Instagram:'#e1306c', LinkedIn:'#0a66c2',
  YouTube:'#ff0000', WhatsApp:'#25d366', Twitter:'#000', Pinterest:'#bd081c',
};

const STATUS_MAP = {
  Draft:             { label:'🎨 In Progress',     color:'var(--accent)' },
  Rejected:          { label:'❌ Rejected',         color:'#e84545' },
  'Pending Internal':{ label:'🔒 Internal Review', color:'#e87830' },
  'Pending Client':  { label:'👔 Client Review',   color:'#6c58f0' },
  Approved:          { label:'✅ Approved',         color:'var(--green)' },
};

const TAB_CONFIG = [
  { id:'pending',  label:'🎨 In Progress',    statuses:['Draft','Rejected'],   color:'var(--accent)' },
  { id:'internal', label:'🔒 Internal Review',statuses:['Pending Internal'],   color:'#e87830' },
  { id:'client',   label:'👔 Client Review',  statuses:['Pending Client'],     color:'#6c58f0' },
  { id:'approved', label:'✅ Approved',        statuses:['Approved'],           color:'var(--green)' },
];

const EMPTY_MSG = {
  pending:  { icon:'🎨', msg:'No creatives in progress',             sub:'Work orders with a Creatives phase unlocked will appear here.' },
  internal: { icon:'🔒', msg:'No creatives pending internal review', sub:'Submit creatives for internal review to see them here.' },
  client:   { icon:'👔', msg:'No creatives pending client review',   sub:'Internally approved creatives will appear here.' },
  approved: { icon:'✅', msg:'No approved creatives yet',            sub:'Client-approved creatives will appear here.' },
};

function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
}

function fmtDateShort(iso) {
  if (!iso) return '—';
  return new Date(iso + 'T00:00:00').toLocaleDateString('en-GB', { weekday:'short', day:'2-digit', month:'short', year:'numeric' });
}

// ── Stage Date Banner (matches blueprint exactly) ─────────────────────────────
function StageDateBanner({ task, eventDate }) {
  const target = task?.deadline || eventDate || null;
  const start  = task?.start    || null;

  if (!target && !start) return null;

  const today = new Date(); today.setHours(0,0,0,0);
  const tD = target ? new Date(target + 'T00:00:00') : null;
  const sD = start  ? new Date(start  + 'T00:00:00') : null;

  const fmt = d => d ? d.toLocaleDateString('en-GB',{weekday:'short',day:'2-digit',month:'short',year:'numeric'}) : '—';

  let urgencyText  = '';
  let bannerBg     = 'linear-gradient(135deg,#1a2340 0%,#0d1b2a 100%)';
  let borderColor  = '#3b7ef0';
  let dateColor    = '#7ec8ff';
  let urgencyColor = '#7ec8ff';

  if (task?.status === 'Done') {
    bannerBg = 'linear-gradient(135deg,#0d2b1e 0%,#081a12 100%)';
    borderColor = '#1db87a'; dateColor = '#4fd6a4';
    urgencyText = '✅ Completed'; urgencyColor = '#4fd6a4';
  } else if (tD) {
    const diffDays = Math.round((tD - today) / 86400000);
    if (diffDays < 0) {
      bannerBg = 'linear-gradient(135deg,#2b0d0d 0%,#1a0808 100%)';
      borderColor = '#e84545'; dateColor = '#ff8080'; urgencyColor = '#ff8080';
      urgencyText = `⚠️ OVERDUE by ${Math.abs(diffDays)} day${Math.abs(diffDays)!==1?'s':''}`;
    } else if (diffDays === 0) {
      bannerBg = 'linear-gradient(135deg,#2b1a0d 0%,#1a0f08 100%)';
      borderColor = '#e87830'; dateColor = '#ffb366'; urgencyColor = '#ffb366';
      urgencyText = '🔥 DUE TODAY';
    } else if (diffDays === 1) {
      bannerBg = 'linear-gradient(135deg,#2b1a0d 0%,#1a0f08 100%)';
      borderColor = '#f7c34f'; dateColor = '#ffe599'; urgencyColor = '#ffe599';
      urgencyText = '⚡ DUE TOMORROW';
    } else if (diffDays <= 3) {
      bannerBg = 'linear-gradient(135deg,#1a1a0d 0%,#0d0d08 100%)';
      borderColor = '#f7c34f'; dateColor = '#ffe599'; urgencyColor = '#ffe599';
      urgencyText = `⏰ ${diffDays} days left`;
    } else if (sD && today < sD) {
      urgencyText = `📅 Starts in ${Math.round((sD-today)/86400000)} days`;
    } else {
      urgencyText = `📅 ${diffDays} days to complete`;
    }
  }

  return (
    <div style={{
      margin:'0 0 12px', padding:'10px 14px',
      background: bannerBg,
      border: `1.5px solid ${borderColor}`,
      borderRadius: 10,
      display:'flex', alignItems:'center', gap:16, flexWrap:'wrap',
      boxShadow: `0 2px 12px ${borderColor}33`,
    }}>
      <div style={{display:'flex',flexDirection:'column',gap:2,flex:1,minWidth:0}}>
        <div style={{fontSize:'0.62rem',fontWeight:700,color:dateColor,opacity:0.7,textTransform:'uppercase',letterSpacing:'0.8px'}}>
          Stage Schedule
        </div>
        <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
          <div style={{display:'flex',flexDirection:'column',gap:1}}>
            <span style={{fontSize:'0.58rem',color:dateColor,opacity:0.6,textTransform:'uppercase',letterSpacing:'0.5px'}}>Start</span>
            <span style={{fontSize:'0.85rem',fontWeight:800,color:dateColor,whiteSpace:'nowrap'}}>{fmt(sD)}</span>
          </div>
          <span style={{fontSize:'1rem',color:dateColor,opacity:0.5,fontWeight:700}}>→</span>
          <div style={{display:'flex',flexDirection:'column',gap:1}}>
            <span style={{fontSize:'0.58rem',color:dateColor,opacity:0.6,textTransform:'uppercase',letterSpacing:'0.5px'}}>Complete by</span>
            <span style={{fontSize:'0.85rem',fontWeight:800,color:dateColor,whiteSpace:'nowrap'}}>{fmt(tD)}</span>
          </div>
        </div>
      </div>
      {urgencyText && (
        <div style={{
          padding:'5px 12px',
          background:`${borderColor}22`,
          border:`1px solid ${borderColor}66`,
          borderRadius:20,
          fontSize:'0.75rem',fontWeight:800,
          color:urgencyColor,whiteSpace:'nowrap',
        }}>{urgencyText}</div>
      )}
    </div>
  );
}

// ── Stage Work Strip ──────────────────────────────────────────────────────────
function StageWorkStrip({ task, onStartWork, onReload }) {
  const [holding, setHolding] = useState(false);
  const [holdReason, setHoldReason] = useState('');

  if (!task) return (
    <div style={{margin:'0 0 14px',padding:'8px 14px',background:'#f7c34f15',border:'1px solid #f7c34f55',borderLeft:'4px solid #e87830',borderRadius:8,display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
      <span style={{fontSize:'0.78rem',fontWeight:700,color:'#9a6800'}}>⚠️ Status strip unavailable</span>
      <span style={{fontSize:'0.72rem',color:'var(--text2)'}}>No workflow tasks exist — push this entry to workflow from Monthly Planner.</span>
    </div>
  );

  const st = task.status;
  const owner = task.assignee || 'Unassigned';

  if (st === 'Locked') return (
    <>
      <StageDateBanner task={task} />
      <div style={{margin:'0 0 14px',padding:'8px 14px',background:'var(--bg3)',border:'1px dashed var(--border2)',borderLeft:'4px solid var(--text3)',borderRadius:8,display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
        <span style={{fontSize:'0.78rem',fontWeight:700,color:'var(--text3)'}}>🔒 Waiting — this stage unlocks when its predecessor completes</span>
        <span style={{padding:'2px 10px',background:'var(--bg2)',border:'1px solid var(--border2)',borderRadius:12,fontSize:'0.72rem',fontWeight:700,color:'var(--text2)',whiteSpace:'nowrap'}}>👤 {owner}</span>
        <span style={{fontSize:'0.72rem',color:'var(--text3)'}}>You can pre-draft; it auto-starts once unlocked.</span>
      </div>
    </>
  );

  if (st === 'Todo') return (
    <>
      <style>{`
        @keyframes wfStartPulse {
          0%,100% { box-shadow: 0 0 0 0 rgba(255,108,55,0.65), 0 8px 22px rgba(255,108,55,0.35); transform: scale(1); }
          50%     { box-shadow: 0 0 0 14px rgba(255,108,55,0), 0 8px 22px rgba(255,108,55,0.55); transform: scale(1.03); }
        }
        @keyframes wfSheen {
          0%   { transform: translateX(-120%) skewX(-22deg); }
          60%  { transform: translateX(220%)  skewX(-22deg); }
          100% { transform: translateX(220%)  skewX(-22deg); }
        }
        @keyframes wfStripBreath {
          0%,100% { background: linear-gradient(90deg, rgba(255,108,55,0.10), rgba(255,108,55,0.03)); }
          50%     { background: linear-gradient(90deg, rgba(255,108,55,0.18), rgba(255,108,55,0.06)); }
        }
        .wf-start-btn {
          position: relative; overflow: hidden;
          padding: 10px 22px; font-size: 0.9rem; font-weight: 900; letter-spacing: 0.4px;
          color: #fff; border: none; border-radius: 10px; cursor: pointer;
          background: linear-gradient(135deg, #ff6c37 0%, #ff8a4a 45%, #ffb04a 100%);
          animation: wfStartPulse 1.6s ease-in-out infinite;
          transition: transform 0.15s ease, filter 0.15s ease;
          text-shadow: 0 1px 1px rgba(0,0,0,0.18);
        }
        .wf-start-btn::after {
          content: ''; position: absolute; top: 0; left: -50%; height: 100%; width: 40%;
          background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.55) 50%, rgba(255,255,255,0) 100%);
          animation: wfSheen 2.6s ease-in-out infinite; pointer-events: none;
        }
        .wf-start-btn:hover { transform: translateY(-1px) scale(1.05); filter: brightness(1.08); }
        .wf-start-btn:active { transform: translateY(0) scale(0.98); }
        .wf-start-strip { animation: wfStripBreath 2.4s ease-in-out infinite; }
      `}</style>
      <StageDateBanner task={task} />
      <div className="wf-start-strip" style={{margin:'0 0 14px',padding:'12px 16px',border:'1px solid #ff6c3744',borderLeft:'4px solid #ff6c37',borderRadius:10,display:'flex',alignItems:'center',gap:14,flexWrap:'wrap'}}>
        <button className="wf-start-btn" onClick={() => onStartWork(task.id)}>
          <span style={{display:'inline-block',animation:'wfArrowNudge 1.2s ease-in-out infinite',marginRight:8}}>▶</span>
          START WORK
        </button>
        <span style={{padding:'3px 11px',background:'rgba(255,255,255,0.9)',border:'1px solid #ff6c3744',borderRadius:14,fontSize:'0.74rem',fontWeight:800,color:'#a8451e',whiteSpace:'nowrap'}}>👤 {owner}</span>
        <span style={{fontSize:'0.8rem',color:'#7a4632'}}><b style={{color:'#a8451e'}}>Ready for you.</b> Press Start so the team sees you're on it.</span>
      </div>
    </>
  );

  if (st === 'In Progress') return (
    <div style={{margin:'0 0 14px',padding:'8px 14px',background:'#1db87a10',border:'1px solid #1db87a33',borderLeft:'4px solid var(--green)',borderRadius:8,display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
      <span style={{width:9,height:9,borderRadius:'50%',background:'var(--green)',display:'inline-block',animation:'crVoicePulse 1.3s ease-in-out infinite'}} />
      <span style={{fontSize:'0.78rem',fontWeight:700,color:'#0f8050'}}>● Working{task.started_at ? ` — since ${fmtDate(task.started_at)}` : ''}</span>
      <span style={{padding:'2px 10px',background:'var(--bg2)',border:'1px solid var(--border2)',borderRadius:12,fontSize:'0.72rem',fontWeight:700,color:'var(--text2)',whiteSpace:'nowrap'}}>👤 {owner}</span>
      <button
        onClick={async () => {
          const reason = prompt('Reason for hold?'); if (!reason) return;
          await api.post(`/tasks/${task.id}/hold`, { reason });
          onReload();
        }}
        style={{marginLeft:'auto',padding:'4px 12px',fontSize:'0.72rem',fontWeight:600,background:'transparent',color:'var(--red)',border:'1px solid var(--red)',borderRadius:6,cursor:'pointer'}}>
        ⏸ Hold
      </button>
    </div>
  );

  if (st === 'Blocked') return (
    <div style={{margin:'0 0 14px',padding:'8px 14px',background:'#e8454512',border:'1px solid #e8454540',borderLeft:'4px solid var(--red)',borderRadius:8,display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
      <span style={{fontSize:'0.78rem',fontWeight:700,color:'var(--red)'}}>⛔ ON HOLD: {task.hold_reason||'—'}</span>
      <span style={{padding:'2px 10px',background:'var(--bg2)',border:'1px solid var(--border2)',borderRadius:12,fontSize:'0.72rem',fontWeight:700,color:'var(--text2)',whiteSpace:'nowrap'}}>👤 {owner}</span>
      <button
        onClick={async () => { await api.post(`/tasks/${task.id}/resume`); onReload(); }}
        style={{marginLeft:'auto',padding:'6px 16px',fontSize:'0.78rem',fontWeight:800,background:'var(--accent)',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',animation:'wfGlow 1.8s ease-in-out infinite'}}>
        ▶ RESUME
      </button>
    </div>
  );

  return (
    <div style={{margin:'0 0 14px',padding:'6px 14px',background:'var(--bg3)',border:'1px solid var(--border2)',borderRadius:8,fontSize:'0.74rem',color:'var(--text3)'}}>
      Stage: <b>{st}</b> · 👤 {owner}
    </div>
  );
}

// ── Version Image Viewer ──────────────────────────────────────────────────────
function VersionImageViewer({ versions, startIdx, onClose }) {
  const withImg = versions.map((v,i) => ({v,i})).filter(x => x.v.image_data || x.v.imageData);
  const [cur, setCur] = useState(() => {
    const idx = withImg.findIndex(x => x.i === startIdx);
    return idx >= 0 ? idx : withImg.length - 1;
  });

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  if (!withImg.length) return null;

  const x = withImg[cur], v = x.v;
  const imgSrc = v.image_data || v.imageData;
  const d = v.at ? new Date(v.at) : null;
  const ds = d && !isNaN(d)
    ? `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`
    : '';

  return (
    <div onClick={onClose}
      style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.82)',zIndex:99999,
        display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:24}}>
      <div style={{color:'#fff',fontWeight:700,marginBottom:10,display:'flex',
        alignItems:'center',gap:12,flexWrap:'wrap',justifyContent:'center'}}>
        <span style={{padding:'3px 12px',background:'var(--accent)',borderRadius:14,fontSize:'0.85rem'}}>
          {v.version}
        </span>
        <span style={{fontSize:'0.85rem'}}>{v.image_name||v.imageName||'Creative'}</span>
        {ds && <span style={{fontSize:'0.75rem',opacity:0.7,fontFamily:'Space Mono,monospace'}}>{ds}</span>}
        {v.by && <span style={{fontSize:'0.75rem',opacity:0.7}}>by {v.by}</span>}
      </div>
      <img src={imgSrc} alt={v.version}
        onClick={e=>e.stopPropagation()}
        style={{maxWidth:'90vw',maxHeight:'62vh',borderRadius:10,
          boxShadow:'0 10px 50px rgba(0,0,0,0.6)',background:'#fff',objectFit:'contain'}} />
      {withImg.length > 1 && (
        <div style={{display:'flex',gap:10,marginTop:14,alignItems:'center',
          flexWrap:'wrap',justifyContent:'center'}}
          onClick={e=>e.stopPropagation()}>
          {withImg.map((x2,j) => (
            <div key={j} onClick={()=>setCur(j)} style={{cursor:'pointer',textAlign:'center'}}>
              <img src={x2.v.image_data||x2.v.imageData} alt={x2.v.version}
                style={{width:74,height:74,objectFit:'cover',borderRadius:8,background:'#fff',
                  border:`3px solid ${j===cur?'var(--accent)':'transparent'}`,
                  transition:'border-color 0.15s'}} />
              <div style={{color:j===cur?'#fff':'rgba(255,255,255,0.6)',fontSize:'0.7rem',
                fontWeight:700,marginTop:2}}>{x2.v.version}</div>
            </div>
          ))}
        </div>
      )}
      <div style={{color:'rgba(255,255,255,0.5)',fontSize:'0.72rem',marginTop:10,textAlign:'center'}}>
        {withImg.length > 1 ? 'Click a thumbnail to compare versions · ' : ''}Click background or press Esc to close
      </div>
      <button onClick={onClose}
        style={{position:'absolute',top:16,right:16,padding:'6px 14px',
          background:'rgba(255,255,255,0.15)',color:'#fff',border:'none',
          borderRadius:6,cursor:'pointer',fontSize:'0.82rem',fontWeight:600}}>
        ✕ Close
      </button>
    </div>
  );
}

function VersionHistory({ versions, isClient, shareWithClient }) {
  const [open, setOpen] = useState(false);
  const [viewerIdx, setViewerIdx] = useState(null);
  if (!versions?.length) return null;
  const actionStyle = {
    'Submitted':          { color:'var(--accent)', icon:'📤' },
    'Internal Approved':  { color:'#e87830',       icon:'✓' },
    'Client Approved':    { color:'var(--green)',   icon:'✅' },
    'Revision Requested': { color:'var(--red)',     icon:'↩' },
  };
  const visibleVersions = isClient
    ? (versions||[]).filter(v =>
        (v.stage === 'client') ||
        (v.action === 'Client Approved') ||
        (v.action === 'Revision Requested' && (v.fbVoiceStage||'internal') === 'client')
      )
    : (versions||[]);

  return (
    <>
      <div style={{marginTop:'14px'}}>
      <div onClick={()=>setOpen(v=>!v)} style={{display:'flex',alignItems:'center',gap:'8px',cursor:'pointer',padding:'6px 0',borderTop:'1px solid var(--border)'}}>
        <span style={{fontSize:'0.72rem',fontWeight:700,color:'var(--text3)'}}>📜 Version History</span>
        <span style={{fontSize:'0.65rem',color:'var(--text3)'}}>{visibleVersions.length} submission{visibleVersions.length!==1?'s':''}</span>
        <span style={{marginLeft:'auto',fontSize:'0.65rem',color:'var(--text3)'}}>{open?'▼':'▶'}</span>
      </div>
      {open && (
        <div>
          {visibleVersions.map((v,i)=>{
            const st = actionStyle[v.action] || { color:'var(--text3)', icon:'•' };
            const showDesigner = !isClient || !!shareWithClient;
            return (
              <div key={i} style={{display:'flex',gap:'10px',padding:'8px 0',borderBottom:'1px solid var(--border)'}}>
                <div style={{display:'flex',flexDirection:'column',alignItems:'center',flexShrink:0}}>
                  <div style={{width:'26px',height:'26px',borderRadius:'50%',background:st.color+'22',border:`2px solid ${st.color}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.7rem',fontWeight:700,color:st.color}}>
                    {v.action==='Submitted' ? v.version : st.icon}
                  </div>
                  {i<visibleVersions.length-1 && <div style={{width:'2px',flex:1,minHeight:'10px',background:'var(--border)',marginTop:'2px'}} />}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap',marginBottom:'4px'}}>
                    <span style={{fontSize:'0.72rem',fontWeight:700,color:st.color}}>{st.icon} {v.action}</span>
                    <span style={{fontSize:'0.68rem',color:'var(--text3)'}}>{fmtDate(v.at)}</span>
                    {v.by && <span style={{fontSize:'0.65rem',color:'var(--text3)'}}>by {v.by}</span>}
                  </div>
                  {v.rejectionReason && (!isClient || (v.stage||'internal')==='client') && <div style={{fontSize:'0.75rem',color:'var(--red)',padding:'3px 8px',background:'#ff000008',borderRadius:'4px',marginBottom:'4px'}}>↩ {v.rejectionReason}</div>}
                  {(v.image_data||v.imageData) && (
                    <div style={{marginTop:6,cursor:'pointer'}} onClick={()=>setViewerIdx(i)}>
                      <img src={v.image_data||v.imageData} alt={v.version}
                        style={{width:80,height:80,objectFit:'cover',borderRadius:6,
                          border:'2px solid var(--accent)',boxShadow:'0 2px 8px rgba(0,0,0,0.15)'}}
                        title="Click to compare versions" />
                      <div style={{fontSize:'0.65rem',color:'var(--accent)',marginTop:2,fontWeight:700}}>🔍 Click to compare</div>
                    </div>
                  )}
                  {v.voiceData && showDesigner && (
                    <div style={{display:'flex',alignItems:'center',gap:'6px',flexWrap:'wrap',marginTop:'4px'}}>
                      <span style={{fontSize:'0.68rem',fontWeight:700,color:'var(--text3)'}}>🎙️ Designer:</span>
                      <audio controls src={v.voiceData} style={{height:'28px',maxWidth:'260px'}} />
                    </div>
                  )}
                  {v.fbVoiceData && (!isClient || v.fbVoiceStage==='client') && (
                    <div style={{display:'flex',alignItems:'center',gap:'6px',flexWrap:'wrap',marginTop:'4px'}}>
                      <span style={{fontSize:'0.68rem',fontWeight:700,color:'var(--red)'}}>🎙️ Reviewer:</span>
                      <audio controls src={v.fbVoiceData} style={{height:'28px',maxWidth:'260px'}} />
                    </div>
                  )}
                  {v.link && <a href={v.link} target="_blank" rel="noreferrer" style={{fontSize:'0.72rem',color:'var(--accent)'}}>🔗 {v.link.length>50?v.link.slice(0,50)+'…':v.link}</a>}
                  {v.notes && showDesigner && <div style={{fontSize:'0.72rem',color:'var(--text2)',marginTop:'2px'}}>💬 {v.notes}</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
      {viewerIdx !== null && (
        <VersionImageViewer
          versions={visibleVersions||[]}
          startIdx={viewerIdx}
          onClose={()=>setViewerIdx(null)}
        />
      )}
    </>
  );
}

function VoiceRecorder({ label, onRecorded, existingAudio, onDelete }) {
  const [recording, setRecording] = useState(false);
  const [timer, setTimer]         = useState(0);
  const mediaRef  = useRef(null);
  const chunksRef = useRef([]);
  const timerRef  = useRef(null);
  const fmtTime   = s => `${Math.floor(s/60)}:${String(s%60).padStart(2,'0')}`;

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream, {
        mimeType: MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/ogg'
      });
      chunksRef.current = [];
      mr.ondataavailable = e => { if (e.data.size>0) chunksRef.current.push(e.data); };
      mr.onstop = () => {
        stream.getTracks().forEach(t=>t.stop());
        clearInterval(timerRef.current);
        const blob = new Blob(chunksRef.current, { type: mr.mimeType });
        const reader = new FileReader();
        reader.onload = ev => onRecorded(ev.target.result, timer);
        reader.readAsDataURL(blob);
        setRecording(false); setTimer(0);
      };
      mr.start(); mediaRef.current = mr;
      setRecording(true); setTimer(0);
      timerRef.current = setInterval(() => {
        setTimer(t => { if (t >= 59) { mediaRef.current?.stop(); return t; } return t + 1; });
      }, 1000);
    } catch { alert('Microphone access denied.'); }
  };
  const stop = () => { mediaRef.current?.stop(); clearInterval(timerRef.current); };

  if (recording) return (
    <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
      <div style={{display:'flex',alignItems:'center',gap:'6px',padding:'4px 12px',background:'#e8454508',border:'1px solid #e84545',borderRadius:'8px'}}>
        <span style={{width:'8px',height:'8px',borderRadius:'50%',background:'#e84545',display:'inline-block'}} />
        <span style={{fontSize:'0.72rem',fontWeight:700,color:'#e84545'}}>Recording {fmtTime(timer)}</span>
      </div>
      <button onClick={stop} style={{padding:'4px 12px',background:'#e84545',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'0.72rem',fontWeight:700}}>⏹ Stop</button>
    </div>
  );
  if (existingAudio) return (
    <div style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap'}}>
      <audio controls src={existingAudio} style={{height:'30px',maxWidth:'280px'}} />
      <button onClick={start} style={{padding:'3px 10px',fontSize:'0.72rem',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:'6px',cursor:'pointer'}}>🔄 Re-record</button>
      <button onClick={onDelete} style={{padding:'3px 10px',fontSize:'0.72rem',background:'none',border:'1px solid var(--border)',borderRadius:'6px',cursor:'pointer',color:'#e84545'}}>🗑 Delete</button>
    </div>
  );
  return (
    <button onClick={start} style={{display:'inline-flex',alignItems:'center',gap:'6px',padding:'5px 12px',fontSize:'0.75rem',fontWeight:600,background:'var(--bg3)',color:'var(--text2)',border:'1px solid var(--border2)',borderRadius:'6px',cursor:'pointer'}}>
      🎙️ {label}
    </button>
  );
}

// ── Script Brief Panel ────────────────────────────────────────────────────────
function BriefField({ label, value, color, multiline, placeholder }) {
  const accents = { green:'#3b7ef0', purple:'#8b5cf6', yellow:'#f59e0b', pink:'#ec4899', teal:'#14b8a6' };
  const accent = accents[color] || 'var(--accent)';
  return (
    <div style={{display:'flex',flexDirection:'column',gap:5}}>
      <div style={{display:'flex',alignItems:'center',gap:5}}>
        <span style={{width:3,height:14,borderRadius:2,background:accent,display:'inline-block',flexShrink:0}}/>
        <label style={{fontSize:'0.7rem',fontWeight:700,letterSpacing:'0.6px',textTransform:'uppercase',color:'#374151'}}>{label}</label>
      </div>
      <div style={{background:'var(--bg3)',border:'1px solid var(--border2)',borderRadius:8,padding:multiline?'9px 12px':'8px 12px',minHeight:multiline?70:'auto',fontSize:'0.82rem',color:value?'var(--text)':'var(--text3)',fontStyle:value?'normal':'italic',lineHeight:1.6,whiteSpace:'pre-wrap',wordBreak:'break-word'}}>
        {value || placeholder || 'Not filled'}
      </div>
    </div>
  );
}

function ScriptBriefPanel({ entry }) {
  const sc = entry.script || {};
  const cb = entry.creative_brief || {};
  const cl = entry.client || {};
  const [previewRef, setPreviewRef] = React.useState(null);
  React.useEffect(()=>{
    const handler=(e)=>{if(e.key==='Escape')setPreviewRef(null);};
    document.addEventListener('keydown',handler);
    return()=>document.removeEventListener('keydown',handler);
  },[]);
  const b = {
    references:       (cb.references?.length ? cb.references : null) || (sc.references?.length ? sc.references : null) || [],
    caption:          cb.caption          || sc.hook    || sc.caption || null,
    sub_caption:      cb.sub_caption      || sc.message || null,
    body_text:        cb.body_text        || sc.script  || null,
    call_to_action:   cb.call_to_action   || sc.cta     || null,
    visual_direction: cb.visual_direction || sc.visual  || null,
    brand_website:    cb.brand_website    || sc.brand_website || cl.website || null,
    brand_email:      cb.brand_email      || sc.brand_email   || cl.email   || null,
    brand_phone:      cb.brand_phone      || sc.brand_phone   || cl.phone   || null,
    brand_address:    cb.brand_address    || sc.brand_address || cl.address || null,
  };
  return (
    <div style={{marginBottom:16,border:'2px solid var(--border2)',borderRadius:12,overflow:'hidden',background:'var(--bg2)',boxShadow:'0 4px 16px rgba(0,0,0,0.06)'}}>
      <div style={{padding:'10px 16px',background:'var(--bg3)',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
        <span style={{fontSize:'0.75rem',fontWeight:700,color:'var(--text)'}}>📋 Script & Brief Reference</span>
        <span style={{fontSize:'0.68rem',color:'var(--text3)',fontStyle:'italic'}}>From Content Briefs — read only</span>
        {(entry.platforms||[]).length>0 && (
          <div style={{display:'flex',gap:4,marginLeft:8}}>
            {(entry.platforms||[]).map(p=>(
              <div key={p} title={p} style={{padding:'2px 6px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:5,fontSize:'0.62rem',fontWeight:600,color:'var(--text2)'}}>
                {p.slice(0,2).toUpperCase()}
              </div>
            ))}
          </div>
        )}
        {entry.campaign_type && (
          <span style={{padding:'2px 8px',background:'rgba(59,126,240,0.08)',border:'1px solid rgba(59,126,240,0.2)',borderRadius:10,fontSize:'0.65rem',fontWeight:600,color:'var(--accent)'}}>
            {entry.campaign_type}
          </span>
        )}
        {(entry.output_formats||[]).length>0 && (
          <div style={{display:'flex',gap:3,flexWrap:'wrap'}}>
            {(entry.output_formats||[]).map((f,i)=>(
              <span key={i} style={{padding:'2px 6px',background:'rgba(108,88,240,0.08)',border:'1px solid rgba(108,88,240,0.2)',borderRadius:8,fontSize:'0.6rem',fontWeight:600,color:'var(--accent2)'}}>
                {f.length>18?f.slice(0,16)+'…':f}
              </span>
            ))}
          </div>
        )}
      </div>
      <div style={{padding:'16px 18px'}}>
        {(()=>{
          const refs = Array.isArray(b.references) ? b.references : [];
          if (!refs.length) return null;
          return (
            <>
            <div style={{marginBottom:14}}>
              <div style={{display:'flex',alignItems:'center',gap:5,marginBottom:8}}>
                <span style={{width:3,height:14,borderRadius:2,background:'#3b7ef0',display:'inline-block'}}/>
                <span style={{fontSize:'0.7rem',fontWeight:700,letterSpacing:'0.6px',textTransform:'uppercase',color:'#374151'}}>References</span>
                <span style={{fontSize:'0.65rem',color:'var(--text3)'}}>({refs.length})</span>
              </div>
              <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                {refs.map((r,i)=>(
                  r.type==='image' ? (
                    <div key={i} style={{display:'flex',flexDirection:'column',alignItems:'center',gap:4}}>
                      <div style={{width:90,height:90,borderRadius:8,border:'1px solid var(--border)',overflow:'hidden',cursor:'zoom-in',position:'relative'}}
                        onClick={()=>setPreviewRef(r)}>
                        <img src={r.data} alt={r.name||'ref'} style={{width:'100%',height:'100%',objectFit:'cover'}} />
                        <div style={{position:'absolute',inset:0,background:'rgba(0,0,0,0)',display:'flex',alignItems:'center',justifyContent:'center',opacity:0,transition:'all 0.2s'}}
                          onMouseOver={e=>{e.currentTarget.style.opacity=1;e.currentTarget.style.background='rgba(0,0,0,0.35)';}}
                          onMouseOut={e=>{e.currentTarget.style.opacity=0;e.currentTarget.style.background='rgba(0,0,0,0)';}}>
                          <span style={{fontSize:'1.4rem'}}>🔍</span>
                        </div>
                      </div>
                      <div style={{fontSize:'0.58rem',color:'var(--text3)',maxWidth:90,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',textAlign:'center'}}>{r.name}</div>
                    </div>
                  ) : r.type==='link' ? (
                    <a key={i} href={r.url||r.data} target="_blank" rel="noreferrer"
                      style={{display:'inline-flex',alignItems:'center',gap:5,padding:'5px 10px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:8,fontSize:'0.72rem',color:'var(--accent)',textDecoration:'none',maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                      🔗 {r.label||r.url||r.data}
                    </a>
                  ) : (
                    <a key={i} href={r.data} download={r.name}
                      style={{display:'inline-flex',alignItems:'center',gap:5,padding:'5px 10px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:8,fontSize:'0.72rem',color:'var(--text2)',textDecoration:'none'}}>
                      📄 {r.name||'File'}
                    </a>
                  )
                ))}
              </div>
            </div>
            {previewRef && (
              <div onClick={()=>setPreviewRef(null)}
                style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.82)',zIndex:99999,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
                <div onClick={e=>e.stopPropagation()}
                  style={{position:'relative',maxWidth:'90vw',maxHeight:'90vh',background:'var(--bg2)',borderRadius:12,overflow:'hidden',boxShadow:'0 24px 64px rgba(0,0,0,0.5)'}}>
                  <button onClick={()=>setPreviewRef(null)}
                    style={{position:'absolute',top:10,right:10,zIndex:10,width:32,height:32,borderRadius:'50%',background:'rgba(0,0,0,0.6)',border:'none',color:'#fff',fontSize:'1rem',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>
                    ✕
                  </button>
                  <img src={previewRef.data} alt={previewRef.name||'preview'}
                    style={{display:'block',maxWidth:'88vw',maxHeight:'85vh',objectFit:'contain'}} />
                  {previewRef.name && (
                    <div style={{padding:'8px 14px',fontSize:'0.75rem',color:'var(--text2)',borderTop:'1px solid var(--border)',background:'var(--bg3)'}}>
                      {previewRef.name}
                      <span style={{marginLeft:8,fontSize:'0.65rem',color:'var(--text3)'}}>Press Esc to close</span>
                    </div>
                  )}
                </div>
              </div>
            )}
            </>
          );
        })()}
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
          <BriefField label="Caption (Main)" value={b.caption}     color="green"  placeholder="No caption entered" />
          <BriefField label="Sub-Caption"    value={b.sub_caption} color="purple" placeholder="No sub caption entered" />
        </div>
        <div style={{marginBottom:12}}>
          <BriefField label="Body Text" value={b.body_text} color="yellow" multiline placeholder="No body text entered" />
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
          <BriefField label="Call to Action"   value={b.call_to_action}   color="pink" placeholder="No CTA entered" />
          <BriefField label="Visual Direction" value={b.visual_direction} color="teal" placeholder="No visual direction entered" />
        </div>
        <div style={{border:'1.5px solid var(--border2)',borderRadius:8,overflow:'hidden'}}>
          <div style={{padding:'8px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:8,background:'var(--bg3)'}}>
            <span style={{fontSize:'0.75rem',fontWeight:700,color:'var(--text)'}}>🏢 Brand Details</span>
            <span style={{fontSize:'0.68rem',color:'var(--text3)',fontStyle:'italic'}}>Pre-filled from client</span>
          </div>
          <div style={{padding:12,display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,background:'var(--bg2)'}}>
            {[
              {label:'Website',   color:'#3b82f6', val:b.brand_website},
              {label:'Email',     color:'#8b5cf6', val:b.brand_email},
              {label:'Contact No',color:'#ef4444', val:b.brand_phone},
              {label:'Address',   color:'#f59e0b', val:b.brand_address},
            ].map(({label,color,val})=>(
              <div key={label}>
                <div style={{display:'flex',alignItems:'center',gap:4,marginBottom:4}}>
                  <span style={{width:3,height:12,borderRadius:2,background:color,display:'inline-block'}}/>
                  <span style={{fontSize:'0.62rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.5px',color:'#374151'}}>{label}</span>
                </div>
                <div style={{background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:6,padding:'6px 10px',fontSize:'0.78rem',color:val?'var(--text)':'var(--text3)',fontStyle:val?'normal':'italic'}}>
                  {val||`Enter ${label.toLowerCase()}`}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Image Lightbox ────────────────────────────────────────────────────────────
function ImageLightbox({ src, name, onClose }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.92)',zIndex:99999,
        display:'flex',alignItems:'center',justifyContent:'center',cursor:'zoom-out'}}>
      <button
        onClick={onClose}
        style={{position:'absolute',top:16,right:16,padding:'6px 14px',
          background:'rgba(255,255,255,0.15)',color:'#fff',border:'none',
          borderRadius:6,cursor:'pointer',fontSize:'0.82rem',fontWeight:600}}>
        ✕ Close
      </button>
      <div style={{textAlign:'center'}} onClick={e=>e.stopPropagation()}>
        <img src={src} alt={name||'creative'}
          style={{maxWidth:'92vw',maxHeight:'88vh',borderRadius:8,
            objectFit:'contain',boxShadow:'0 8px 48px rgba(0,0,0,0.6)'}} />
        {name && (
          <div style={{color:'rgba(255,255,255,0.6)',fontSize:'0.75rem',marginTop:8}}>
            {name}
          </div>
        )}
      </div>
    </div>
  );
}

// ── Creative Card ─────────────────────────────────────────────────────────────
function CreativeCard({ entry, creative, tab, onSave, onSubmitInternal, onApproveInternal, onApproveClient, onReject, onReload, isClient, onActivate, isActive }) {
  const cr           = creative || {};
  const status       = cr.status || 'Draft';
  const isReadonly   = status === 'Approved';
  const canSubmit    = status === 'Draft' || status === 'Rejected';
  const isInternal   = status === 'Pending Internal';
  const isPendClient = status === 'Pending Client';

  const [link,         setLink]        = useState(cr.link || '');
  const [notes,        setNotes]       = useState(cr.notes || '');
  const [voiceData,    setVoiceData]   = useState(cr.voice_data || null);
  const [fbVoice,      setFbVoice]     = useState(cr.fb_voice_data || null);
  const [shareDesign,  setShareDesign] = useState(cr.share_with_client || false);
  const [rejectReason, setRejectReason]= useState('');
  const [saving,       setSaving]      = useState(false);
  const [imagePreview, setImagePreview]= useState(cr.image_data || null);
  const [imageName,    setImageName]   = useState(cr.image_name || null);
  const [scriptOpen,   setScriptOpen]  = useState(false);
  const [lightbox,     setLightbox]    = useState(false);
  const fileRef = useRef(null);

  const accentColor = STATUS_MAP[status]?.color || 'var(--accent)';
  const [ey,em,ed]  = (entry.event_date||'').split('-');
  const woNum       = entry.wo_number || '—';
  const task        = entry.task || null;
  const formats     = entry.output_formats || [];

  const handleImage = (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    const originalMB = (file.size / 1024 / 1024).toFixed(1);
    const reader = new FileReader();
    reader.onload = ev => {
      const img = new Image();
      img.onload = () => {
        const MAX_DIM = 1200;
        let w = img.width, h = img.height;
        if (w > MAX_DIM || h > MAX_DIM) {
          if (w > h) { h = Math.round(h * MAX_DIM / w); w = MAX_DIM; }
          else        { w = Math.round(w * MAX_DIM / h); h = MAX_DIM; }
        }
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        const compressed = canvas.toDataURL('image/jpeg', 0.75);
        const compressedKB = Math.round(compressed.length * 0.75 / 1024);
        setImagePreview(compressed);
        setImageName(file.name);
        if (parseFloat(originalMB) > 0.5) {
          console.log(`📎 Compressed: ${file.name} → ${compressedKB}KB (was ${originalMB}MB)`);
        }
      };
      img.onerror = () => { setImagePreview(ev.target.result); setImageName(file.name); };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(entry.id, { link, notes, voice_data: voiceData, image_data: imagePreview, image_name: imageName, share_with_client: shareDesign });
      return true;
    } catch(e) {
      const msg = e.response?.data?.message || e.message || 'Save failed';
      alert('❌ Save failed: ' + msg + '\n\nIf you attached a large image, try using a Google Drive link instead.');
      return false;
    } finally { setSaving(false); }
  };

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const saved = await handleSave();
      if (!saved) return;
      await onSubmitInternal(entry.id);
    } finally { setSaving(false); }
  };

  const handleReject = async () => {
    if (!rejectReason.trim()) { alert('Please enter a revision note.'); return; }
    await onReject(entry.id, rejectReason, fbVoice);
    setRejectReason('');
  };

  const handleStartWork = async (taskId) => {
    try {
      await api.post(`/tasks/${taskId}/start`);
      onReload();
    } catch (e) { console.error('Start work failed', e); }
  };

  const platforms    = entry.platforms    || [];
  const campaignName = entry.campaign_type || '';
  const clientName   = entry.client_name  || entry.client || '';

  const approvalSteps = [
    { n:1, label:'Internal Review',  sub: status==='Pending Internal'?'Pending your review': (cr.internal_approved_by?`Approved by ${cr.internal_approved_by}`:'Not started'), done: ['Pending Client','Approved'].includes(status)||!!cr.internal_approved_by, active: status==='Pending Internal' },
    { n:2, label:'Client Approval',  sub: status==='Pending Client'?'Pending client review': (cr.client_approved_by?`Approved by ${cr.client_approved_by}`:'Awaiting internal'), done: status==='Approved', active: status==='Pending Client' },
    { n:3, label:'Final Approved',   sub:'Ready for scheduling', done: status==='Approved', active:false },
  ];

  return (
    <div style={{marginBottom:'20px'}} id={`cr-card-${entry.id}`}>
      <div style={{
        background:'var(--bg2)',
        border:'2px solid var(--border2)',
        borderRadius:'var(--radius)',
        overflow:'hidden',
        boxShadow:'0 2px 12px rgba(0,0,0,0.08)',
      }}>
        {/* Header */}
        <div style={{padding:'12px 16px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
          <span style={{fontFamily:'Space Mono,monospace',fontWeight:800,color:'var(--accent)',fontSize:'0.9rem'}}>{woNum}</span>
          <span className="badge badge-blue" style={{borderRadius:6}}>{clientName}</span>
          <span style={{fontWeight:600,fontSize:'0.88rem',color:'var(--text)'}}>{entry.title}</span>
          {entry.event_date && (
            <span style={{fontSize:'0.8rem',color:'var(--text2)',display:'flex',alignItems:'center',gap:4}}>
              <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="12" height="11" rx="1.5"/><line x1="5" y1="1" x2="5" y2="4"/><line x1="11" y1="1" x2="11" y2="4"/><line x1="2" y1="7" x2="14" y2="7"/></svg>
              Event: {ed}-{em}-{ey}
            </span>
          )}
          <div style={{marginLeft:'auto',display:'flex',alignItems:'center',gap:8}}>
            <button onClick={() => setScriptOpen(v => !v)}
              style={{display:'inline-flex',alignItems:'center',gap:6,padding:'5px 12px',fontSize:'0.75rem',fontWeight:700,
                background:scriptOpen?'var(--accent)':'linear-gradient(135deg,#3b7ef0,#6c58f0)',
                color:'#fff',border:'none',borderRadius:7,cursor:'pointer',transition:'all 0.15s'}}>
              📋 {scriptOpen ? 'Hide Brief ▲' : 'View Brief ▼'}
            </button>
            <span style={{padding:'4px 12px',background:`${accentColor}18`,border:`1px solid ${accentColor}44`,borderRadius:20,fontSize:'0.72rem',fontWeight:700,color:accentColor}}>
              {STATUS_MAP[status]?.label||status}
            </span>
          </div>
        </div>

        {/* Two-column body */}
        <div style={{display:'grid',gridTemplateColumns:'1fr 280px',alignItems:'start'}}>

          {/* Left column */}
          <div style={{borderRight:'1px solid var(--border)',padding:'16px 20px'}}>

          {entry.platforms?.length > 0 && (
            <div style={{display:'flex',gap:'6px',flexWrap:'wrap',marginBottom:'10px'}}>
              {entry.platforms.map(p => (
                <div key={p} style={{display:'inline-flex',alignItems:'center',gap:'4px',padding:'2px 8px',background:'var(--bg3)',border:'1px solid var(--border)',borderRadius:'6px',fontSize:'0.72rem',fontWeight:600,color:PLATFORM_COLOR[p]||'var(--text2)'}}>
                  {PLATFORM_SVG[p]||null} {p}
                </div>
              ))}
            </div>
          )}

          {canSubmit && (
            <StageWorkStrip
              task={task}
              onStartWork={handleStartWork}
              onReload={onReload}
            />
          )}

          {cr.rejection_reason && canSubmit && (
            <div style={{padding:'8px 12px',background:'#ff000010',border:'1px solid #ff000030',borderRadius:'6px',fontSize:'0.78rem',color:'var(--red)',marginBottom:'12px'}}>↩ Rejected: {cr.rejection_reason}</div>
          )}

          {cr.fb_voice_data && canSubmit && (
            <div style={{padding:'8px 12px',background:'#ff000008',border:'1px solid #ff000020',borderRadius:'6px',marginBottom:'12px',display:'flex',alignItems:'center',gap:'10px',flexWrap:'wrap'}}>
              <span style={{fontSize:'0.72rem',fontWeight:700,color:'var(--red)'}}>🎙️ REVIEWER VOICE FEEDBACK:</span>
              <audio controls src={cr.fb_voice_data} style={{height:'32px',maxWidth:'300px'}} />
            </div>
          )}

          {canSubmit && (
            <>
              <div className="form-group" style={{marginBottom:'10px'}}>
                <label className="form-label">📎 Creative File <span style={{fontWeight:400,color:'var(--text3)',fontSize:'0.72rem'}}>— attach image or paste Drive/Dropbox link</span></label>
                <div style={{display:'flex',gap:'8px',marginBottom:'8px',flexWrap:'wrap'}}>
                  <label style={{display:'inline-flex',alignItems:'center',gap:'6px',padding:'6px 14px',background:'var(--accent)',color:'#fff',borderRadius:'6px',cursor:'pointer',fontSize:'0.78rem',fontWeight:600}}>
                    📁 Attach Image
                    <input ref={fileRef} type="file" accept="image/*" style={{display:'none'}} onChange={handleImage} />
                  </label>
                  <input type="url" className="form-input" value={link} onChange={e=>setLink(e.target.value)}
                    placeholder="Or paste Google Drive / Dropbox link..." style={{flex:1,minWidth:'200px'}} />
                </div>
                {imagePreview && (
                  <div style={{position:'relative',display:'inline-block'}}>
                    <img src={imagePreview} alt="creative"
                    onClick={()=>setLightbox(true)}
                    style={{maxWidth:'200px',maxHeight:'140px',borderRadius:'8px',border:'1px solid var(--border)',objectFit:'cover',cursor:'zoom-in'}}
                    title="Click to view full size" />
                    <button onClick={()=>{setImagePreview(null);setImageName(null);}} style={{position:'absolute',top:'-6px',right:'-6px',width:'20px',height:'20px',borderRadius:'50%',background:'var(--red)',color:'#fff',border:'none',cursor:'pointer',fontSize:'0.65rem'}}>✕</button>
                    <div style={{fontSize:'0.7rem',color:'var(--text3)',marginTop:'4px'}}>🖼️ {imageName}</div>
                  </div>
                )}
                {!imagePreview && link && (
                  <div style={{padding:'8px 12px',background:'var(--bg3)',borderRadius:'6px',display:'flex',alignItems:'center',gap:'8px'}}>
                    <span>🔗</span>
                    <a href={link} target="_blank" rel="noreferrer" style={{color:'var(--accent)',fontSize:'0.82rem',flex:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{link}</a>
                  </div>
                )}
              </div>
              <div className="form-group" style={{marginBottom:'12px'}}>
                <label className="form-label">💬 Designer Notes / Changes Made</label>
                <textarea className="form-textarea" value={notes} onChange={e=>setNotes(e.target.value)}
                  style={{height:'60px'}} placeholder="Describe what was created, design decisions, changes from last version..." />
              </div>
              <div className="form-group" style={{marginBottom:'12px'}}>
                <label className="form-label">🎙️ Voice Note <span style={{fontWeight:400,color:'var(--text3)',fontSize:'0.72rem'}}>— optional spoken note for reviewers (max 1 min)</span></label>
                <VoiceRecorder label="Record Voice Note" onRecorded={(audio)=>setVoiceData(audio)} existingAudio={voiceData} onDelete={()=>setVoiceData(null)} />
              </div>
            </>
          )}

          {!canSubmit && (
            <>
              <div style={{marginBottom:'12px'}}>
                <div style={{fontSize:'0.68rem',fontWeight:700,color:'var(--text3)',marginBottom:'6px',textTransform:'uppercase'}}>📎 CREATIVE FILE</div>
                {cr.image_data
                  ? <div>
                      <img src={cr.image_data} alt="creative"
                        onClick={()=>setLightbox('versions')}
                        style={{maxWidth:'240px',maxHeight:'160px',borderRadius:'8px',border:'1px solid var(--border)',objectFit:'cover',cursor:'zoom-in'}}
                        title="Click to view full size / compare versions" />
                      {(cr.versions||[]).filter(v=>v.image_data||v.imageData).length > 0 && (
                        <div style={{fontSize:'0.65rem',color:'var(--accent)',marginTop:4,fontWeight:700,cursor:'pointer'}}
                          onClick={()=>setLightbox('versions')}>
                          🔍 Click image to compare versions
                        </div>
                      )}
                    </div>
                  : cr.link
                  ? <div style={{display:'flex',alignItems:'center',gap:'8px',padding:'8px 12px',background:'var(--bg3)',borderRadius:'6px'}}>
                      <span>🔗</span>
                      <a href={cr.link} target="_blank" rel="noreferrer" style={{color:'var(--accent)',fontSize:'0.82rem',flex:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{cr.link}</a>
                    </div>
                  : <span style={{fontSize:'0.78rem',color:'var(--text3)'}}>No file attached yet</span>}
              </div>
              {cr.notes && (!isPendClient || cr.share_with_client) && (
                <div style={{padding:'8px 12px',background:'var(--bg3)',borderRadius:'6px',fontSize:'0.82rem',marginBottom:'10px'}}>💬 {cr.notes}</div>
              )}
              {cr.voice_data && (!isPendClient || cr.share_with_client) && (
                <div style={{marginBottom:'10px'}}>
                  <div style={{fontSize:'0.68rem',fontWeight:700,color:'var(--text3)',marginBottom:'4px'}}>🎙️ DESIGNER VOICE NOTE</div>
                  <audio controls src={cr.voice_data} style={{height:'32px',maxWidth:'300px'}} />
                </div>
              )}
            </>
          )}

          {(isInternal || isPendClient) && (
            <div style={{marginBottom:'12px'}}>
              <label className="form-label" style={{fontSize:'0.72rem'}}>Revision / Rejection Notes</label>
              <input className="form-input" value={rejectReason} onChange={e=>setRejectReason(e.target.value)} placeholder="Describe what needs to change..." style={{marginBottom:'8px'}} />
              <div style={{display:'flex',alignItems:'center',gap:'10px',flexWrap:'wrap',marginTop:'4px'}}>
                <VoiceRecorder label="Record Voice Feedback" onRecorded={(audio)=>setFbVoice(audio)} existingAudio={fbVoice} onDelete={()=>setFbVoice(null)} />
              </div>
              {isInternal && (
                <label style={{display:'inline-flex',alignItems:'center',gap:'6px',marginTop:'10px',padding:'4px 10px',background:shareDesign?'#dcfce7':'var(--bg3)',border:'1px solid',borderColor:shareDesign?'#16a34a':'var(--border)',borderRadius:'6px',cursor:'pointer',fontSize:'0.78rem',fontWeight:600,color:shareDesign?'#16a34a':'var(--text2)'}}>
                  <input type="checkbox" checked={shareDesign} onChange={e=>setShareDesign(e.target.checked)} style={{width:'14px',height:'14px',accentColor:'var(--accent)',cursor:'pointer'}} />
                  {shareDesign ? '✓ Sharing designer notes & voice with client' : '📤 Share designer notes & voice with client'}
                </label>
              )}
            </div>
          )}

          {/* Action buttons */}
          <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'center',paddingTop:4}}>
            {canSubmit && <>
              <button onClick={handleSave} disabled={saving}
                style={{display:'inline-flex',alignItems:'center',gap:7,padding:'8px 18px',fontSize:'0.82rem',fontWeight:600,background:'var(--bg2)',color:'var(--text2)',border:'1.5px solid var(--border2)',borderRadius:8,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
                onMouseOver={e=>{e.currentTarget.style.borderColor='var(--accent)';e.currentTarget.style.color='var(--accent)';}}
                onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border2)';e.currentTarget.style.color='var(--text2)';}}>
                <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M13 13H3a1 1 0 01-1-1V3a1 1 0 011-1h8l2 2v9a1 1 0 01-1 1z"/><path d="M5 13V9h6v4"/><path d="M5 2h4v3H5z"/></svg>
                {saving ? 'Saving…' : 'Save as Draft'}
              </button>
              <button onClick={handleSubmit} disabled={saving}
                style={{display:'inline-flex',alignItems:'center',gap:8,padding:'8px 20px',fontSize:'0.82rem',fontWeight:700,background:'linear-gradient(135deg,#4f7cf7,#7c5cf6)',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',boxShadow:'0 2px 8px rgba(79,124,247,0.35)',transition:'all 0.15s',fontFamily:'inherit'}}
                onMouseOver={e=>{e.currentTarget.style.transform='translateY(-1px)';}}
                onMouseOut={e=>{e.currentTarget.style.transform='translateY(0)';}}>
                <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="15" y1="1" x2="7" y2="9"/><polygon points="15,1 10,15 7,9 1,6"/></svg>
                Submit for Internal Review
              </button>
            </>}
            {isInternal && <>
              <button onClick={()=>onApproveInternal(entry.id)}
                style={{display:'inline-flex',alignItems:'center',gap:7,padding:'8px 18px',fontSize:'0.82rem',fontWeight:700,background:'linear-gradient(135deg,#16a34a,#22c47a)',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',boxShadow:'0 2px 8px rgba(22,163,74,0.3)',transition:'all 0.15s',fontFamily:'inherit'}}
                onMouseOver={e=>e.currentTarget.style.filter='brightness(1.08)'} onMouseOut={e=>e.currentTarget.style.filter='none'}>
                <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.5 8.5l3.5 3.5 7-7"/></svg>
                Approve → Send to Client
              </button>
              <button onClick={handleReject}
                style={{display:'inline-flex',alignItems:'center',gap:7,padding:'8px 18px',fontSize:'0.82rem',fontWeight:700,background:'var(--bg2)',color:'#ef4444',border:'1.5px solid rgba(239,68,68,0.35)',borderRadius:8,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
                onMouseOver={e=>{e.currentTarget.style.background='rgba(239,68,68,0.06)';e.currentTarget.style.borderColor='#ef4444';}}
                onMouseOut={e=>{e.currentTarget.style.background='var(--bg2)';e.currentTarget.style.borderColor='rgba(239,68,68,0.35)';}}>
                ↩ Request Revision
              </button>
            </>}
            {isPendClient && <>
              <button onClick={()=>onApproveClient(entry.id)}
                style={{display:'inline-flex',alignItems:'center',gap:8,padding:'8px 20px',fontSize:'0.84rem',fontWeight:700,background:'linear-gradient(135deg,#16a34a,#22c47a)',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',boxShadow:'0 2px 8px rgba(22,163,74,0.3)',transition:'all 0.15s',fontFamily:'inherit'}}
                onMouseOver={e=>e.currentTarget.style.filter='brightness(1.08)'} onMouseOut={e=>e.currentTarget.style.filter='none'}>
                <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.5 8.5l3.5 3.5 7-7"/></svg>
                Approve
              </button>
              <button onClick={handleReject}
                style={{display:'inline-flex',alignItems:'center',gap:7,padding:'8px 18px',fontSize:'0.82rem',fontWeight:700,background:'var(--bg2)',color:'#ef4444',border:'1.5px solid rgba(239,68,68,0.35)',borderRadius:8,cursor:'pointer',transition:'all 0.15s',fontFamily:'inherit'}}
                onMouseOver={e=>{e.currentTarget.style.background='rgba(239,68,68,0.06)';e.currentTarget.style.borderColor='#ef4444';}}
                onMouseOut={e=>{e.currentTarget.style.background='var(--bg2)';e.currentTarget.style.borderColor='rgba(239,68,68,0.35)';}}>
                ↩ Request Revision
              </button>
            </>}
            {isReadonly && (
              <span style={{display:'inline-flex',alignItems:'center',gap:6,padding:'7px 14px',fontSize:'0.78rem',fontWeight:700,color:'#22c47a',background:'rgba(34,196,122,0.08)',border:'1px solid rgba(34,196,122,0.25)',borderRadius:8}}>
                ✓ Approved & Ready for Scheduling
              </span>
            )}
          </div>

            <VersionHistory versions={cr.versions||[]} isClient={isPendClient || isClient} shareWithClient={cr.share_with_client} />
            <FinalFilesSection woId={entry.id} formats={formats} isApproved={isReadonly} />
          </div>

          {/* Right Panel */}
          <div style={{padding:'16px',display:'flex',flexDirection:'column',gap:14,background:'var(--bg3)'}}>
            <div>
              <div style={{fontSize:'0.72rem',fontWeight:700,color:'var(--text)',marginBottom:10}}>Publishing Summary</div>
              {platforms.length>0 && (
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                  <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72}}>Platforms</span>
                  <div style={{display:'flex',gap:4,flexWrap:'wrap'}}>
                    {platforms.map(p=>(
                      <div key={p} title={p} style={{padding:'2px 6px',background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:5,fontSize:'0.62rem',fontWeight:600,color:'var(--text2)'}}>
                        {p.slice(0,2).toUpperCase()}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {formats.length>0 && (
                <div style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:8}}>
                  <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72,paddingTop:2}}>Formats</span>
                  <div style={{display:'flex',gap:3,flexWrap:'wrap'}}>
                    {formats.map((f,i)=>(
                      <span key={i} style={{padding:'2px 6px',background:'rgba(108,88,240,0.08)',border:'1px solid rgba(108,88,240,0.2)',borderRadius:8,fontSize:'0.6rem',fontWeight:600,color:'var(--accent2)'}}>
                        {f.length>18?f.slice(0,16)+'…':f}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {campaignName && (
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
                  <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72}}>Campaign</span>
                  <span style={{fontSize:'0.72rem',color:'var(--text2)',fontWeight:500}}>{campaignName}</span>
                </div>
              )}
              <div style={{display:'flex',alignItems:'center',gap:8}}>
                <span style={{fontSize:'0.68rem',color:'var(--text3)',minWidth:72}}>Client</span>
                <span style={{fontSize:'0.72rem',color:'var(--text2)',fontWeight:500}}>{clientName}</span>
              </div>
            </div>

            <div style={{height:1,background:'var(--border)'}}/>

            <div>
              <div style={{fontSize:'0.72rem',fontWeight:700,color:'var(--text)',marginBottom:10}}>Approval Workflow</div>
              {approvalSteps.map((step,si)=>(
                <div key={step.n} style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:si<2?12:0,position:'relative'}}>
                  {si<2 && <div style={{position:'absolute',left:10,top:22,width:1.5,height:14,background:'var(--border)'}}/>}
                  <div style={{width:22,height:22,borderRadius:'50%',flexShrink:0,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.65rem',fontWeight:800,
                    background:step.done?'#22c47a':step.active?'var(--accent)':'var(--bg4)',
                    color:step.done||step.active?'#fff':'var(--text3)',
                    border:step.done||step.active?'none':'1.5px solid var(--border2)'}}>
                    {step.done?'✓':step.n}
                  </div>
                  <div style={{flex:1,paddingTop:1}}>
                    <div style={{fontSize:'0.76rem',fontWeight:600,color:step.done?'#22c47a':step.active?'var(--accent)':'var(--text2)'}}>{step.label}</div>
                    <div style={{fontSize:'0.66rem',color:'var(--text3)',marginTop:1}}>{step.sub}</div>
                  </div>
                </div>
              ))}
            </div>

            {(cr.versions||[]).length>0 && <>
              <div style={{height:1,background:'var(--border)'}}/>
              <div>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                  <span style={{fontSize:'0.72rem',fontWeight:700,color:'var(--text)'}}>Version History</span>
                  <span style={{fontSize:'0.62rem',color:'var(--text3)'}}>{cr.versions.length} version{cr.versions.length!==1?'s':''}</span>
                </div>
                {[...cr.versions].reverse().slice(0,4).map((v,i)=>{
                  const vColor = v.action?.includes('Approved')?'#22c47a':v.action?.includes('Reject')||v.action?.includes('Revision')?'var(--red)':'var(--accent)';
                  const vDate  = v.at ? new Date(v.at) : null;
                  const vFmt   = vDate ? `${String(vDate.getDate()).padStart(2,'0')} ${vDate.toLocaleString('en-IN',{month:'short'})} ${vDate.getFullYear()}, ${String(vDate.getHours()).padStart(2,'0')}:${String(vDate.getMinutes()).padStart(2,'0')} ${vDate.getHours()>=12?'PM':'AM'}` : '';
                  return (
                    <div key={i} style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:10}}>
                      <div style={{width:8,height:8,borderRadius:'50%',background:vColor,flexShrink:0,marginTop:5}}/>
                      <div style={{flex:1}}>
                        <div style={{fontSize:'0.7rem',fontWeight:600,color:vColor}}>{v.action}</div>
                        {v.by && <div style={{fontSize:'0.62rem',color:'var(--text3)'}}>by {v.by}</div>}
                        {vFmt && <div style={{fontSize:'0.6rem',color:'var(--text3)',fontFamily:'Space Mono,monospace'}}>{vFmt}</div>}
                        {v.rejectionReason && <div style={{fontSize:'0.62rem',color:'var(--red)',marginTop:2}}>↩ {v.rejectionReason}</div>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </>}
          </div>
        </div>
      </div>

      {scriptOpen && <ScriptBriefPanel entry={entry} />}
      {lightbox === true && (
        <ImageLightbox
          src={imagePreview || cr.image_data}
          name={imageName || cr.image_name}
          onClose={()=>setLightbox(false)}
        />
      )}
      {lightbox === 'versions' && (
        <VersionImageViewer
          versions={[
            ...(cr.image_data ? [{
              image_data: cr.image_data,
              image_name: cr.image_name,
              version: 'Current',
              at: cr.updated_at,
              by: cr.internal_approved_by || cr.posted_by || '',
              action: 'Current',
              stage: 'client',
            }] : []),
            ...(() => {
              const vers = cr.versions || [];
              const clientImages = [];
              for (let i = 0; i < vers.length; i++) {
                const v = vers[i];
                if (v.image_data || v.imageData) {
                  const isClientStage = (v.stage||'internal') === 'client';
                  const nextV = vers[i+1];
                  const precedesClientApproval = nextV && nextV.action === 'Internal Approved' && (nextV.stage||'internal') === 'client';
                  if (!isPendClient || isClientStage || precedesClientApproval) {
                    clientImages.push({...v});
                  }
                }
              }
              return clientImages;
            })(),
          ]}
          startIdx={0}
          onClose={()=>setLightbox(false)}
        />
      )}
    </div>
  );
}

export default function Creatives() {
  const [searchParams] = useSearchParams();
  const urlTab = searchParams.get("tab");
  const urlWo = searchParams.get("wo");
  const { user } = useAuth();
  const { canTab } = useAuth();
  const allowedCreativeTabs = TAB_CONFIG
    .filter(t => { const cfg = (OPERATIONS_TABS.creatives||[]).find(x=>x.id===t.id); return !cfg?.permissionKey || canTab(cfg.permissionKey); });
  const [tab,       setTab]      = useState(urlTab && allowedCreativeTabs.find(t=>t.id===urlTab) ? urlTab : (allowedCreativeTabs[0]?.id || 'pending'));
  const [entries,   setEntries]  = useState([]);
  const [loading,   setLoading]  = useState(true);
  const [yearF,     setYearF]    = useState('');
  const [monthsF,   setMonthsF]  = useState(new Set());
  const [showMonthDd,setShowMonthDd]= useState(false);
  const [clientF,   setClientF]  = useState('');
  const [woFilter,   setWoFilter]  = useState('');
  const [activeWOId, setActiveWOId] = useState(null);
  const [urlWoHandled, setUrlWoHandled] = useState(false);
  const [wftF,      setWftF]     = useState('');
  const [clients,   setClients]  = useState([]);
  const [wftypes,   setWftypes]  = useState([]);
  const [counts,    setCounts]   = useState({});
  const [hidePosted, setHidePosted] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (clientF) params.client_id = clientF;
      if (wftF)    params.campaign_type_id = wftF;
      const [entRes, clRes, wfRes] = await Promise.all([
        api.get('/creatives', { params }),
        api.get('/clients'),
        api.get('/campaign-types'),
      ]);
      setEntries(entRes.data.data || []);
      setClients(clRes.data.data  || clRes.data || []);
      setWftypes(wfRes.data.data  || wfRes.data || []);
      const all = entRes.data.data || [];
      const c = { pending:0, internal:0, client:0, approved:0 };
      all.forEach(e => {
        const st = e.creative?.status || 'Draft';
        if (st==='Draft'||st==='Rejected'||!e.creative) c.pending++;
        if (st==='Pending Internal')                     c.internal++;
        if (st==='Pending Client')                       c.client++;
        if (st==='Approved')                             c.approved++;
      });
      setCounts(c);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [clientF, wftF]);

  useEffect(() => { load(); }, [load]);

  // Auto-open WO from URL param
  useEffect(() => {
    if (urlWo && entries.length > 0 && !urlWoHandled) {
      const match = entries.find(e => e.wo_number === urlWo || String(e.id) === urlWo);
      if (match) { setActiveWOId(match.id); }
      setUrlWoHandled(true);
    }
  }, [urlWo, entries, urlWoHandled]);

  const currentYear = new Date().getFullYear();
  const yearOptions = [currentYear - 1, currentYear, currentYear + 1].map(String);
  const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const toggleMonth = m => setMonthsF(prev => { const s = new Set(prev); s.has(m) ? s.delete(m) : s.add(m); return s; });

  useEffect(() => {
    if (!showMonthDd) return;
    const h = e => { if (!e.target.closest('[data-month-dd]')) setShowMonthDd(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [showMonthDd]);

  const approvedCount = entries.filter(e => {
    const st = e.creative?.status || 'Draft';
    if (st !== 'Approved') return false;
    if (hidePosted && e.sch_state === 'posted') return false;
    return true;
  }).length;
  const displayCounts = { ...counts, approved: approvedCount };

  const filtered = entries.filter(e => {
    if (woFilter && !(e.wo_number||'').toLowerCase().includes(woFilter.toLowerCase())) return false;
    const st  = e.creative?.status || 'Draft';
    const cfg = TAB_CONFIG.find(t=>t.id===tab);
    if (!cfg?.statuses.includes(st)) return false;
    if (e.event_date) {
      if (yearF && e.event_date.slice(0, 4) !== yearF) return false;
      if (monthsF.size > 0) { const eMonth = parseInt(e.event_date.split('-')[1], 10); if (!monthsF.has(eMonth)) return false; }
    }
    if (tab === 'approved' && hidePosted && e.sch_state === 'posted') return false;
    return true;
  });

  const handleSave            = async (woId, data) => {
    try {
      await api.put(`/creatives/${woId}`, data);
      load();
    } catch(e) { throw e; }
  };
  const handleSubmit          = async (woId)        => { await api.post(`/creatives/${woId}/submit-internal`); load(); };
  const handleApproveInternal = async (woId)        => { await api.post(`/creatives/${woId}/approve-internal`); load(); };
  const handleApproveClient   = async (woId)        => { await api.post(`/creatives/${woId}/approve-client`); load(); };
  const handleReject          = async (woId, reason, fbVoice) => { await api.post(`/creatives/${woId}/reject`, { reason, fb_voice_data: fbVoice }); load(); };

  return (
    <div>
      <div style={{position:'sticky',top:'-24px',zIndex:30,background:'var(--bg)',margin:'-24px -24px 16px',padding:'24px 24px 0'}}>
        <div style={{display:'flex',gap:0,marginBottom:'16px',borderBottom:'2px solid var(--border)'}}>
          {TAB_CONFIG.map(t => (
            <button key={t.id} onClick={()=>setTab(t.id)}
              style={{padding:'8px 20px',fontSize:'0.82rem',fontWeight:700,border:'none',background:'none',cursor:'pointer',color:tab===t.id?t.color:'var(--text3)',borderBottom:tab===t.id?`3px solid ${t.color}`:'3px solid transparent',marginBottom:'-2px'}}>
              {t.label} {displayCounts[t.id]>0 && <span style={{marginLeft:'4px',padding:'1px 6px',background:t.color+'22',color:t.color,borderRadius:'10px',fontSize:'0.7rem',fontWeight:800}}>{displayCounts[t.id]}</span>}
            </button>
          ))}
          <div style={{marginLeft:'auto'}} />
        </div>

        <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap',alignItems:'center'}}>
            <div style={{position:'relative',display:'flex',alignItems:'center'}}>
              <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="var(--text3)" strokeWidth="1.5" style={{position:'absolute',left:8,pointerEvents:'none'}}><circle cx="6.5" cy="6.5" r="4.5"/><line x1="10" y1="10" x2="14" y2="14"/></svg>
              <input value={woFilter||''} onChange={e=>setWoFilter(e.target.value)}
                placeholder="WO number..." style={{padding:'5px 10px',paddingLeft:26,width:130,fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)'}} />
              {woFilter && <span onClick={()=>setWoFilter('')} style={{position:'absolute',right:8,cursor:'pointer',color:'var(--text3)',fontSize:'0.8rem'}}>✕</span>}
            </div>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={clientF} onChange={e=>setClientF(e.target.value)}>
              <option value="">All Clients</option>
              {clients.filter(c=>c.enabled!==false).map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={wftF} onChange={e=>setWftF(e.target.value)}>
              <option value="">All Workflow Types</option>
              {wftypes.map(wt=><option key={wt.id} value={wt.id}>{wt.name}</option>)}
            </select>
            <select style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text)',cursor:'pointer',width:'auto'}} value={yearF} onChange={e=>setYearF(e.target.value)}>
              <option value="">All Years</option>
              {yearOptions.map(y=><option key={y} value={y}>{y}</option>)}
            </select>
            {/* Multi-month dropdown */}
            <div data-month-dd style={{position:'relative'}}>
              <button onClick={()=>setShowMonthDd(v=>!v)}
                style={{padding:'5px 10px',fontSize:'0.78rem',borderRadius:6,cursor:'pointer',
                  display:'flex',alignItems:'center',gap:5,whiteSpace:'nowrap',
                  background:monthsF.size>0?'#6c58f022':'var(--bg2)',
                  border:`1px solid ${monthsF.size>0?'#6c58f0':'var(--border)'}`,
                  color:monthsF.size>0?'#6c58f0':'var(--text)'}}>
                📅 {monthsF.size===0?'All Months':[...monthsF].sort((a,b)=>a-b).map(m=>MONTH_NAMES[m-1]).join(', ')}
                <span style={{fontSize:'0.6rem',marginLeft:2}}>▾</span>
              </button>
              {showMonthDd&&(
                <div style={{position:'absolute',top:'110%',left:0,zIndex:200,
                  background:'var(--bg)',border:'1px solid var(--border)',borderRadius:8,
                  boxShadow:'0 8px 24px rgba(0,0,0,0.15)',padding:10,minWidth:200}}>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:4}}>
                    {MONTH_NAMES.map((name,i)=>{const m=i+1;const on=monthsF.has(m);return(
                      <button key={m} onClick={()=>toggleMonth(m)}
                        style={{padding:'5px 8px',fontSize:'0.73rem',fontWeight:on?700:500,
                          borderRadius:6,border:`1px solid ${on?'#6c58f0':'var(--border)'}`,
                          background:on?'#6c58f0':'var(--bg2)',
                          color:on?'#fff':'var(--text2)',cursor:'pointer'}}>
                        {name}
                      </button>
                    );})}
                  </div>
                  <div style={{display:'flex',justifyContent:'space-between',marginTop:8,gap:6}}>
                    <button onClick={()=>setMonthsF(new Set())}
                      style={{flex:1,padding:'4px',fontSize:'0.68rem',borderRadius:6,cursor:'pointer',
                        border:'1px solid var(--border)',background:'var(--bg2)',color:'var(--text3)'}}>Clear</button>
                    <button onClick={()=>setShowMonthDd(false)}
                      style={{flex:1,padding:'4px',fontSize:'0.68rem',fontWeight:700,borderRadius:6,
                        cursor:'pointer',border:'none',background:'#6c58f0',color:'#fff'}}>Done</button>
                  </div>
                </div>
              )}
            </div>
          {tab === 'approved' && (
            <button onClick={()=>setHidePosted(v=>!v)}
              style={{padding:'5px 12px',fontSize:'0.78rem',fontWeight:600,borderRadius:6,cursor:'pointer',whiteSpace:'nowrap',
                border:`1px solid ${hidePosted?'var(--border)':'#1db87a'}`,
                background:hidePosted?'var(--bg2)':'#1db87a22',
                color:hidePosted?'var(--text2)':'#1db87a'}}>
              {hidePosted ? '👁 Show Posted' : '🙈 Hide Posted'}
            </button>
          )}
          {(tab==='internal'||tab==='client') && filtered.length > 0 && (
            <button onClick={async()=>{ for(const e of filtered) await handleApproveInternal(e.id); }} style={{padding:'5px 14px',fontSize:'0.78rem',fontWeight:700,background:'var(--green)',color:'#fff',border:'none',borderRadius:6,cursor:'pointer',whiteSpace:'nowrap'}}>✅ Approve Selected</button>
          )}
        </div>
      </div>

      {activeWOId && (()=>{
        const aEntry = filtered.find(e=>e.id===activeWOId);
        if(!aEntry) return null;
        return (
          <div style={{position:'fixed',top:60,right:0,bottom:0,width:300,background:'var(--bg2)',borderLeft:'1px solid var(--border)',overflowY:'auto',zIndex:50,boxShadow:'-4px 0 24px rgba(0,0,0,0.12)',padding:16,display:'flex',flexDirection:'column',gap:12}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:4}}>
              <span style={{fontWeight:700,fontSize:'0.85rem',color:'var(--text)'}}>{aEntry.wo_number} · {aEntry.title}</span>
              <button onClick={()=>setActiveWOId(null)} style={{background:'none',border:'none',cursor:'pointer',color:'var(--text3)',fontSize:18,lineHeight:1}}>✕</button>
            </div>
            <DetailPanel wo={aEntry} sc={aEntry.creative||{}} type="creatives" onClose={()=>setActiveWOId(null)} />
          </div>
        );
      })()}

      {loading ? (
        <div style={{padding:'48px',textAlign:'center',color:'var(--text3)'}}>Loading...</div>
      ) : filtered.length === 0 ? (
        <div style={{padding:'48px',textAlign:'center',color:'var(--text3)'}}>
          <div style={{fontSize:'2.5rem',marginBottom:'12px'}}>{EMPTY_MSG[tab]?.icon}</div>
          <div style={{fontWeight:700}}>{EMPTY_MSG[tab]?.msg}</div>
          <div style={{fontSize:'0.78rem',color:'var(--text3)',marginTop:'6px'}}>{EMPTY_MSG[tab]?.sub}</div>
        </div>
      ) : (
        filtered.map(e => (
          <CreativeCard key={e.id} entry={e} creative={e.creative} tab={tab}
            isClient={user?.role==='client'}
            onSave={handleSave} onSubmitInternal={handleSubmit}
            onApproveInternal={handleApproveInternal} onApproveClient={handleApproveClient}
            onReject={handleReject} onReload={load}
            onActivate={()=>setActiveWOId(id=>id===e.id?null:e.id)}
            isActive={activeWOId===e.id} />
        ))
      )}
    </div>
  );
}